import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 14/16;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 14 16" version="1.1">
        <path d="M11.182 8.551l-1.073-2.145L9.037 8.55l2.145.001zm-2.923 1.553l-.566 1.131a.778.778 0 1 1-1.39-.695l3.11-6.222a.778.778 0 0 1 1.391 0l3.11 6.222a.778.778 0 1 1-1.39.695l-.564-1.128-3.7-.003zM6.223 0h.775a.778.778 0 0 1 0 1.555h-.775c-.862 0-1.557.695-1.557 1.558v9.328c0 .862.695 1.557 1.557 1.557h.775a.778.778 0 0 1 0 1.556h-.775A3.103 3.103 0 0 1 3.888 14.5a3.103 3.103 0 0 1-2.335 1.054H.778a.778.778 0 1 1 0-1.556h.775c.862 0 1.556-.695 1.556-1.557V3.113c0-.863-.695-1.558-1.556-1.558H.778A.778.778 0 1 1 .778 0h.775c.93 0 1.765.407 2.335 1.053A3.104 3.104 0 0 1 6.223 0z" fill={color} fillRule="evenodd"  />
    </svg>
)

export default class IconDoc extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
